import { render, staticRenderFns } from "./veJkyPaper.vue?vue&type=template&id=2d95db28&scoped=true"
import script from "./veJkyPaper.vue?vue&type=script&lang=js"
export * from "./veJkyPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95db28",
  null
  
)

export default component.exports